<div
  [class.hidden]="isLoading || activeMessages.length === 0"
  class="grid grid-cols-[28px_1fr_28px] items-center py-2 bg-[#1C2D36] min-h-[44px] z-[9999]">

  <!-- Left arrow -->
  @if (activeMessages.length > 1 && currentIndex > 0) {
  <button
    class="flex items-center justify-center w-7 h-7 rounded-full text-white opacity-100 hover:bg-white/10 transition-all duration-200"
    (click)="prev()"
    aria-label="Anterior">
    <app-metro-icon [svg]="APP_ICONS.chevronLeft" size="16"></app-metro-icon>
  </button>
  } @else {
  <div class="w-7"></div>
  }

  <!-- Message -->
  <span class="text-center text-[0.8125rem] font-semibold text-[#F6F4F0] leading-tight truncate">
    {{ currentMessage }}
  </span>

  <!-- Right arrow -->
  @if (activeMessages.length > 1 && currentIndex < activeMessages.length - 1) {
  <button
    class="flex items-center justify-center w-7 h-7 rounded-full text-white opacity-100 hover:bg-white/10 transition-all duration-200 justify-self-end"
    (click)="next()"
    aria-label="Siguiente">
    <app-metro-icon [svg]="APP_ICONS.chevronRight" size="16"></app-metro-icon>
  </button>
  } @else {
  <div class="w-7"></div>
  }
</div>

<!-- Modal Popup for Communication Image -->
@if (showModal && currentModalImage) {
<div class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/70" (click)="closeModal()">
  <div class="relative w-[65vw] max-w-none" (click)="$event.stopPropagation()">
    <!-- Image container: no fixed height, wraps to image content -->
    <div class="bg-white rounded-2xl shadow-[0_0_40px_rgba(0,0,0,0.5)] overflow-hidden w-full relative">
      <!-- Close button -->
      <button
        (click)="closeModal()"
        class="absolute top-1.5 right-1.5 text-gray-700 hover:text-gray-900 p-1 transition-colors z-10"
        aria-label="Cerrar">
        <app-metro-icon [svg]="APP_ICONS.close" size="24"></app-metro-icon>
      </button>
      
      <img 
        [src]="currentModalImage" 
        alt="Comunicación" 
        class="w-full max-h-[85vh] object-contain block"
      >
    </div>
  </div>
</div>
}
